module.exports = __webpack_public_path__ + "img/light-mud-decal-20.72a15194.png";